<template lang="pug">
div
  page-error(v-if='state.error')
  breadcrumbs-layout(v-else, :breadcrumbs='crumbs')
    card-page-layout(
      :title='state.name',
      :geo='geo',
      :review-count='reviewsCount',
      :descriptionProps='descriptionProps',
      :sidebarProps='sidebarProps',
      :offsetSetup='isHasModulePfdod',
      :teachersList='teachersList',
      :modulesList='modulesList',
      :currentView='currentTab',
      @need-reviews='loadReviews',
      @need-questionnaire='loadQuestionnaire',
      @tab-changed='onChangeTab'
    )
      template(v-if='isEventRequest', slot='eventRequest')
        EventRequestForm(
          :users='requestUsers',
          :isLoading='isLoading',
          :is-request-executed='isRequestExecuted',
          :message='requestFinishMsg',
          :errors='requestErrors',
          @submitRequest='submitRequest',
          @understood='closeEventRequestForm',
          @cancelRequest='closeEventRequestForm'
        )
      ButtonCanRequest(
        slot='sidebarButtonPlace',
        :isPossible='canRequest',
        :wide='true',
        :disabledRequest='disabledRequest',
        @click='onRequest'
      )
      ButtonDeferred(slot='sidebarAfterButton')
      NewProgramButton(
        slot='sidebarAfterButton',
        @program='openAddProgramForm'
      )
      reviews-block(
        slot='compReview',
        :reviews='reviews',
        :reviewSuccess='reviewPopup',
        :reviewError='reviewError',
        :userData='userData',
        :auth='isAuthorized',
        @submitReview='submitReview',
        @closePopup='closePopup'
      )
      Questionnaire(
        slot='questionnaire',
        :auth='isAuthorized',
        :error='anketaError',
        :noitemText='noItemText',
        :messageText='messageText',
        :showMessage='showAnketaMessage',
        :isAnketaLoading='isAnketaLoading',
        :allQuestionnaire='allQuestionnaire',
        :mainDescription='mainAnketaDescription',
        @formSubmit='formSubmit',
        @getQuestionList='getLists',
        @closeWarning='closeAnketaWarning'
      )
      slider-badges(
        v-if='isHasBadges',
        slot='badges',
        :interval='3000',
        :items='badgesList'
      )
      slider-images.custom-size(
        slot='slider',
        :items='sliderImages',
        :color='colorMenuSection'
      )
      ButtonCanRequest(
        slot='footer',
        :isPossible='canRequest',
        :wide='false',
        :disabledRequest='disabledRequest',
        :requestTooltipText='requestTooltipText',
        @click='onRequest'
      )
    extra-layout(
      v-if='eventsRecommendedList',
      bg='gray',
      :slot='recommendPosition'
    )
      recommended-list(
        :usePadding='true',
        :items='eventsRecommendedList',
        :doubler='false'
      )
        h3(slot='title') Рекомендуем посмотреть
  ExtraLayout(v-if='listOfCards.length', bg='gray')
    AppCardsList(
      title='Обучающие организации',
      v-if='eduPartnersList && eduPartnersList.length'
    )
      MiniCard(
        v-for='(item, index) in eduPartnersList',
        :key='index',
        route-name='organization',
        :id='item.id',
        :title='item.name',
        :image='item.images ? item.images.url : null'
      )
    AppCardsList(v-for='item in listOfCards', v-bind='item', :key='item.title')
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { pcDecode } from '@/tools/punycode';
import CardPageLayout from '@/components/parts/catalog/card';
import EventRequestForm from '@/components/parts/catalog/card/components/request';
import createStoreModule from './store';
import mixin from '../mixin';
import reviewMixin from './../../review-mixin';
import moduleShow from '@/mixins/moduleShow';
import routeProps from '@/mixins/routeProps';
import isAuthorized from '@/mixins/isAuthorized';
import userData from '@/mixins/userData';
import KidsLimitMixin from '@/mixins/kidsLimitMixin';
import PageError from '../../404.vue';
import {
  Breadcrumbs as BreadcrumbsLayout,
  Extra as ExtraLayout,
} from '@/components/layout';
import { List as RecommendedList } from '@/components/parts/catalog/list';
import ButtonCanRequest from '@/presets/button/can-request';
import SliderBadges from '@/components/parts/slider/badges';
import SliderImages from '@/components/parts/slider/images';
import { PanelPopup } from '@/components/panel';
import ReviewsBlock from '@/components/parts/reviews';
import ButtonDeferred from './button-deferred';
import NewProgramButton from './newProgramButton';
import Questionnaire from '@/components/parts/questionnaire';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import RegularLink from '@/components/regularLink';
import isLocation from '@/mixins/isLocation';
import { oredersService } from '@/services';
import { AppCardsList } from '@/uikit';

import listCardSetup from '@/tools/listCardSetup';

import {
  NO_ITEM_TEXT,
  REQUEST_TOOLTIP,
  COMPETTENCE_CARD,
  PROFESSIONS_CARD,
  STORE_MODULE_NAME,
  COMPETTENCE_TITLE,
  PROFESSIONS_TITLE,
  ERROR_DEFAULT_TEXT,
  PF_DOD_CERTIFICATE,
  SUCCESS_ANKETA_TEXT,
  ADD_REVIEW_IMMEDIATELY,
  MAIN_ANKETA_DESCRIPTION,
} from './const.js';

import { HASH_MODAL } from '@/pages/default/popup/forms/const.js';
import { inviteService } from '../../../services';
import MiniCard from './components/MiniCard';
import EventOrderProcess from '@/components/ordersProcessForms/event/EventOrderProcess.vue';

const VueScrollTo = require('vue-scrollto');

export default {
  inject: ['$api', '$eventVisitHistory', '$config'],

  mixins: [
    mixin,
    userData,
    routeProps,
    moduleShow,
    isLocation,
    reviewMixin,
    isAuthorized,
    KidsLimitMixin,
  ],

  components: {
    MiniCard,
    PageError,
    PanelPopup,
    ExtraLayout,
    RegularLink,
    SliderBadges,
    SliderImages,
    ReviewsBlock,
    AppCardsList,
    Questionnaire,
    CardPageLayout,
    ButtonDeferred,
    RecommendedList,
    EventRequestForm,
    ButtonCanRequest,
    NewProgramButton,
    BreadcrumbsLayout,
    EventOrderProcess,
  },

  storeName: STORE_MODULE_NAME,

  storeRegister: createStoreModule,

  asyncData({
    store,
    router,
    route: {
      params: { id, code },
    },
  }) {
    const init = () =>
      store.dispatch(`${STORE_MODULE_NAME}/init`, { id, code });
    return code
      ? init()
      : new Promise((resolve, reject) => {
          store
            .dispatch(`${STORE_MODULE_NAME}/loadEvent`, { id, code })
            .then((response) => {
              const eventRoute = {
                name: 'event-card',
                params: { id, code: response.data.url_code },
              };
              reject({
                message: 'Moved Permanently',
                code: 301,
                data: router.resolve(eventRoute).href,
              });
            })
            .catch((error) => {
              resolve(init());
            });
        });
  },

  properties: {
    speed: {
      type: Number,
      default: 500,
    },

    easing: {
      type: String,
      default: 'ease-in-out',
    },
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },

    code: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    isEventRequest: false,
    isLoading: false,
    isRequestExecuted: false,
    requestFinishMsg: null,
    requestErrors: null,
    frComponent: false,
    requestData: {},
    descriptionProps: {},
    reviewProps: {},
    sidebarProps: {},
    deferredRequest: false,
    certificateLink: { name: PF_DOD_CERTIFICATE },
    mainAnketaDescription: MAIN_ANKETA_DESCRIPTION,
    noItemText: NO_ITEM_TEXT,
    anketaError: false,
    showAnketaMessage: false,
    isAnketaLoading: true,
    currentTab: 'Description',
    timerId: null,
    // usersByInvites: null,
  }),

  computed: {
    canonicalLink() {
      const {
        $router,
        state: { id, url_code },
      } = this;
      const code = url_code;
      if (id) {
        return this.$router.resolve({
          name: 'event-card',
          params: { id, code },
        }).href;
      }
      return '';
    },

    competensesList() {
      return this.state.competensesList;
    },

    professionsList() {
      return this.state.professionsList;
    },
    eduPartnersList() {
      return this.state.eduPartners;
    },

    listOfCards() {
      const { competensesList, professionsList } = this;
      return [
        ...listCardSetup(PROFESSIONS_TITLE, PROFESSIONS_CARD, professionsList),
        ...listCardSetup(COMPETTENCE_TITLE, COMPETTENCE_CARD, competensesList),
      ];
    },

    eventsRecommendedList() {
      const { recommended } = this.state;
      if (isArrayNotEmpty(recommended)) return recommended;
      return false;
    },

    badgesList() {
      const result = [];
      if (this.isOvz) result.push('ovz');
      if (this.isFree) result.push('free');
      return result;
    },

    isHasBadges() {
      return !!this.badgesList.length;
    },

    ovzDiseases() {
      const { ovz_diseases } = this.state;
      const { dictionaryDisease } = this.$store.state;
      if (!Array.isArray(ovz_diseases)) return [];
      return ovz_diseases
        .map((id) => {
          const founded =
            Array.isArray(dictionaryDisease) &&
            dictionaryDisease.find((el) => el.id === id);
          return founded && founded.name;
        })
        .filter((el) => !!el);
    },

    state() {
      return this.$store.state[STORE_MODULE_NAME];
    },

    colorMenuSection() {
      const { colorMenuSection } = this.$store.state.regionProfile;
      return colorMenuSection ? `#${colorMenuSection}` : '#8164a6';
    },

    geo() {
      const result = [];
      const { locations } = this.state;
      if (locations && locations.length) {
        locations.map((item) => {
          const { lat, lng, location } = item;
          if (lat && lng) result.push({ lat, lng, location });
        });
      }
      return result;
    },

    reviewsCount() {
      const { reviews, state } = this;
      return isArrayNotEmpty(reviews)
        ? reviews.length
        : parseInt(state.reviews_count, 10);
    },

    sectionData() {
      const sections = this.$store.state.sections;
      return (
        sections &&
        sections.filter((item) => item.code == this.state.section_code)[0]
      );
    },

    subsectionData() {
      const { sectionData } = this;
      return (
        sectionData &&
        sectionData.children &&
        sectionData.children.filter(
          (item) => item.code == this.state.sub_section_code
        )[0]
      );
    },

    crumbs() {
      return this.breadcrumbs.concat([{ text: this.state.name }]);
    },

    isMunicipalityId() {
      const { municipality_id } = this.state;
      return municipality_id;
    },

    municipalityLink() {
      const { isMunicipalityId } = this;
      return isMunicipalityId
        ? isMunicipalityId.map((el) => ({
            name: 'events',
            query: {
              municipality: el,
            },
          }))
        : null;
    },

    municipalityName() {
      const { isMunicipalityId, $store } = this;
      const { municipalities } = $store.state;
      return isMunicipalityId.map((el) => {
        let municipality;
        municipality = municipalities.filter(
          (item) => Number(item.id) === Number(el)
        )[0];
        return (municipality && municipality.name) || '';
      });
    },

    partnerLink() {
      const { isMunicipalityId, partner_id, region_id } = this.state;
      const query = { organizer: partner_id };
      if (isMunicipalityId) query.municipality = isMunicipalityId;
      if (region_id) query.region = region_id;
      return { name: 'events', query };
    },

    partnerName() {
      const { organizators } = this.$store.state;
      const organizer = organizators.find(
        (item) => Number(item.id) === Number(this.state.partner_id)
      );
      return organizer ? organizer.name : '';
    },

    sliderImages() {
      const { image, images } = this.state;
      return isArrayNotEmpty(images)
        ? images.map((image) => image.big)
        : image
        ? [image.big]
        : [];
    },

    mainImageUrl() {
      const { sliderImages } = this;
      return isArrayNotEmpty(sliderImages) ? sliderImages[0] : '';
    },

    isHasModulePfdod() {
      return this.$store.getters.hasApiModulePfdod;
    },

    isOvz() {
      return this.state.is_ovz;
    },

    isFree() {
      return this.state.is_free;
    },

    isSignificant() {
      const { sub_section_significant } = this.state;
      return this.setBoolean(sub_section_significant);
    },

    askButtonLink() {
      return { hash: HASH_MODAL };
    },

    canRequest() {
      const { is_open } = this.state;
      return is_open || false;
    },

    disabledRequest() {
      return this.state.disabledRequest;
    },

    recommendPosition() {
      // return !this.canRequest ? 'before' : 'after';
      return 'after';
    },

    formList() {
      return this.$store.state.nokoQuestionnaireForm;
    },

    isFormList() {
      const { formList } = this;
      return formList.length > 0;
    },

    answerList() {
      const { answer_list, question_list } = this.state;
      let result = [];
      if (isArrayNotEmpty(answer_list) && isArrayNotEmpty(question_list)) {
        answer_list[0].answers.forEach(({ question_id, value }) => {
          question_list.filter(({ id, text }) => {
            if (id === question_id) result.push({ text, value });
          });
        });
      }
      return result;
    },

    questionList() {
      const { formList, isFormList, state } = this;
      const { question_list } = state;
      if (isArrayNotEmpty(question_list) && isFormList) {
        return {
          description: this.formDescription(formList, question_list),
          questions: question_list,
        };
      }
      return null;
    },

    messageText() {
      const { anketaError } = this;
      return anketaError ? ERROR_DEFAULT_TEXT : SUCCESS_ANKETA_TEXT;
    },

    allQuestionnaire() {
      const { formList, isFormList, answerList, questionList } = this;
      return isFormList ? { formList, answerList, questionList } : null;
    },

    teachersList() {
      return this.state.teachers_list || [];
    },

    modulesList() {
      return this.state.modules || [];
    },

    dataIsLoaded() {
      const { dataIsLoaded } = this.state;
      return dataIsLoaded || false;
    },

    requestTooltipText() {
      return REQUEST_TOOLTIP(this.state.name);
    },

    programmType() {
      const {
        state: { type },
        $store: {
          state: { programmTypes },
        },
      } = this;

      if (!isArrayNotEmpty(programmTypes) || !type) return '';

      const result = programmTypes.find(({ id }) => id === +type);
      return result && result.name ? result.name : '';
    },

    requestUsers() {
      const { user } = this.$store.state;
      if (!user || !user.profile) return [];
      const usersResult = [{ id: user.profile.id, fullName: user.profile.fio }];

      return usersResult;
    },
  },

  watch: {
    isAuthorized(value) {
      if (value && this.deferredRequest) {
        this.deferredRequest = false;
        this.$nextTick(() => this.onRequest());
      }
      this.sidebarProps.questionLink = this.askButtonLink;
    },

    isFormList(value) {
      if (value) this.loadQuestionnaire();
    },

    dataIsLoaded(newV) {
      if (!newV) return;
      this.saveVisitToHistory();
      this.currentTab = 'Description';
      this.sidebarProps = this.getSidebarProps();
      this.reviewProps = this.getReviewProps();
      this.descriptionProps = this.getDescriptionProps();
    },
  },

  async created() {
    const { reviews } = this.state;
    const { isAuthorized, isFormList } = this;
    if (isAuthorized && !isFormList) {
      this.$store.dispatch('getQuestionnaireForm');
    }
    if (reviews && Array.isArray(reviews)) this.localReviews = [...reviews];
    this.sidebarProps = this.getSidebarProps();
    this.reviewProps = this.getReviewProps();
    this.descriptionProps = this.getDescriptionProps();
    // this.usersByInvites = await this.getUsersByInvites();
  },

  mounted() {
    const { $route } = this;
    if ($route.query.request === 'auto') this.onRequest();
    this.saveVisitToHistory();
  },

  beforeDestroy() {
    clearTimeout(this.timerId);
    if (this.isEventRequest) this.closeEventRequestForm();
  },

  methods: {
    setBoolean(data) {
      return data ? (data == 1 ? true : false) : false;
    },

    onRequest(groupId, yearId) {
      const { canRequest, isAuthorized } = this;
      if (canRequest && isAuthorized) {
        this.$ui.$modal.show('eventOrderProcess', {
          settings: {
            size: {
              width: '710px',
              minHeight: '500px',
              height: 'auto',
            },
            title: 'Запись на программу',
          },
          bind: this,
          slots: {
            body: {
              component: EventOrderProcess,
              propsData: {
                /// orderBinds: this.orderBinds,
                /// isError: this.isError,
              },
            },
          },
        });
        // this.openEventRequestForm();
        // this.showRequest();
      } else {
        this.deferredRequest = true;
        this.$router.push({
          hash: this.$util.getRouteHashAllowAuthMethod(
            this.$store.state.apiModules
          ),
        });
      }
    },

    openEventRequestForm() {
      this.isEventRequest = true;
    },

    closeEventRequestForm() {
      this.isEventRequest = false;
      if (this.isRequestExecuted) this.isRequestExecuted = false;
      if (this.requestErrors) this.requestErrors = null;
    },

    showRequest() {
      this.$nextTick(() => {
        if (this.$el.getElementsByClassName('form').length) {
          VueScrollTo.scrollTo('.form', this.speed, {
            offset: -250,
            easing: this.easing,
          });
        } else if (this.$el.getElementsByClassName('__panel')) {
          VueScrollTo.scrollTo('.__panel', this.speed, {
            offset: -100,
            easing: this.easing,
          });
        }
      });
    },

    loadReviews() {
      this.$api
        .get('events/reviews/get', {
          params: { event_id: this.state.id },
        })
        .then((res) => {
          this.localReviews = res.data.data;
        })
        .catch((err) => {
          this.localReviews = [];
        });
    },

    submitReview(fields) {
      const data = {
        ...fields,
        event_id: this.state.id,
      };
      this.$api
        .post('events/review/create', { data })
        .then((res) => {
          if (ADD_REVIEW_IMMEDIATELY) {
            // Сразу добавим отзыв в список
            this.localReviews.push(data);
          } else {
            // TODO FIXIT показать попап с сообщением о добавлении отзыва
            this.reviewPopup = true;
          }
        })
        .catch((err) => {
          // Вывести сообщение об ошибке
          this.reviewError =
            err.response && err.response.data
              ? err.response.data.errors
              : ERROR_DEFAULT_TEXT;
        });
    },

    getDescriptionProps() {
      const { announce, description, teachers, seoFooter, video, length_text } =
        this.state;
      const {
        education_plan,
        exercise_description,
        program_target,
        expected_results,
        education_form,
        schedule_description,
        price_description,
        special_conditions,
        material_base,
      } = this.state;

      return {
        announce,
        description,
        teachers,
        seoFooter,
        video,
        length: length_text,
        educationPlan: education_plan,
        exerciseDescription: exercise_description,
        programTarget: program_target,
        expectedResults: expected_results,
        educationForm: education_form,
        scheduleDescription: schedule_description,
        priceDescription: price_description,
        specialConditions: special_conditions,
        materialBase: material_base,
      };
    },

    getReviewProps() {
      const {
        reviews,
        signinRoute,
        reviewResult,
        reviewError,
        userData,
        submitReview,
      } = this;

      return {
        reviews,
        signinRoute,
        reviewResult,
        reviewError,
        userData,
        submitReview,
        hasProfile: !!this.$store.state.user.profile,
      };
    },

    getSidebarProps() {
      const {
        geo,
        askButtonLink,
        certificateLink,
        municipalityLink,
        municipalityName,
        partnerLink,
        partnerName,
        isOvz,
        ovzDiseases,
        programmType,
      } = this;

      const {
        name,
        locations,
        metro,
        partner_phone,
        partner_email,
        partner_site,
        form_education_name,
        labor_program,
        edu_mode,
        edu_cats,
        cost,
        is_free,
        is_open,
        edu_doc_name,
        qualification_level_id,
        partner_id,
        is_dot,
      } = this.state;

      const isLinkSite = partner_site
        ? partner_site.includes('http://') || partner_site.includes('https://')
        : false;
      const partnerSite = partner_site ? pcDecode(partner_site) : '';

      return {
        geo,
        locations,
        metro,
        certificateLink,
        municipalityLink,
        municipalityName,
        partnerLink,
        partnerName,
        isOvz,
        ovzDiseases,
        partnerPhone: partner_phone,
        partnerEmail: partner_email,
        partnerSite,
        isLinkSite,
        educationForm: form_education_name,
        questionLink: askButtonLink,
        laborProgram: labor_program,
        educationMode: edu_mode,
        programmType,
        educationCategory: edu_cats,
        finishResult: qualification_level_id,
        title: name,
        cost: cost ? `${cost} ₽` : '',
        isFree: is_free,
        isOpen: is_open,
        eduDocName: edu_doc_name,
        partnerId: partner_id,
        isDot: is_dot,
      };
    },

    saveVisitToHistory() {
      this.$nextTick(() => {
        const { $eventVisitHistory } = this;
        if (!$eventVisitHistory) {
          return;
        }

        const {
          announce,
          id,
          image = {},
          name,
          section_code,
          sub_section_code,
          url_code,
          is_locked,
          available_order_next_year,
          available_order_current_year,
        } = this.state;

        $eventVisitHistory.save({
          id,
          code: url_code,
          image: {
            small: !isEmpty(image) && image.little ? image.little : '',
          },
          title: name,
          note: announce,
          price: null,
          section_code,
          sub_section_code,
          is_locked,
          available_order_next_year,
          available_order_current_year,
        });
      });
    },

    loadQuestionnaire() {
      const {
        formList,
        isFormList,
        user: { profile },
      } = this;
      if (isFormList && profile) this.getLists(formList[0].id);
    },

    getLists(id) {
      const { id: target_id } = this.state;
      this.isAnketaLoading = true;
      Promise.all([
        this.$store.dispatch(`${STORE_MODULE_NAME}/getAnswerList`, {
          id,
          target_id,
        }),
        this.$store.dispatch(`${STORE_MODULE_NAME}/getQuestionList`, id),
      ])
        .then(() => {
          this.isAnketaLoading = false;
        })
        .catch((error) => {
          this.anketaError = true;
        });
    },

    formDescription(list, question) {
      if (isArrayNotEmpty(question) && isArrayNotEmpty(list)) {
        const result = list.find(({ id }) => id === question[0].form_id);
        return result ? result.description : '';
      }
      return '';
    },

    formSubmit(payload) {
      const { id } = this.state;
      const data = {
        target_id: id,
        ...payload,
      };
      this.$api
        .post('noko/result/create', { data })
        .then(() => {
          this.showAnketaMessage = true;
          if (this.$el.getElementsByClassName('tabs-container').length > 0) {
            VueScrollTo.scrollTo('.tabs-container', this.speed, {
              offset: -130,
              easing: this.easing,
            });
          }
        })
        .catch((err) => {
          this.anketaError = true;
        });
    },

    closeAnketaWarning() {
      if (this.showAnketaMessage) {
        this.showAnketaMessage = false;
        this.loadQuestionnaire();
      }

      if (this.anketaError) {
        this.anketaError = false;
        this.currentTab = 'Description';
      }
    },

    onChangeTab(name) {
      this.currentTab = name;
    },

    openAddProgramForm() {
      if (this.isAuthorized) {
        this.$router.push({ name: 'new-program' });
      } else {
        this.$router.push({
          hash: this.$util.getRouteHashAllowAuthMethod(
            this.$store.state.apiModules
          ),
        });
      }
    },

    async submitRequest(value) {
      const {
        $api,
        state: { event_id },
      } = this;

      this.isLoading = true;
      const tempValue = {
        ...value,
        students: [
          {
            id: value.studentId,
            edu_level: value.eduLevel,
          },
        ],
      };
      try {
        this.requestFinishMsg = null;
        await oredersService($api).postOrderRequest({
          ...tempValue,
          event_id,
        });
        this.isLoading = false;
        this.requestFinishMsg = {
          type: 'success',
        };
        this.isRequestExecuted = true;
      } catch (err) {
        this.isLoading = false;
        if (err.response.data) {
          const { errors } = err.response.data;
          let firstErrorMsg = null;
          const errorsArr = Array.isArray(errors)
            ? errors
            : Object.values(errors);
          if (errorsArr.length && errorsArr[0].errors) {
            firstErrorMsg = errorsArr[0].errors[0] || null;
          }

          this.requestFinishMsg = {
            type: 'error',
            text: {
              ...(firstErrorMsg &&
                firstErrorMsg.msg && { description: firstErrorMsg.msg }),
            },
          };
          this.isRequestExecuted = true;
        }
      }
    },
  },

  metaInfo() {
    const state = this.$store.state[STORE_MODULE_NAME];
    const { $config, $route, canonicalLink, mainImageUrl } = this;
    const ogUrl = `${$config.mainURL}${$route.fullPath.substring(1)}`;
    return {
      title: state.seo_title || state.name || '',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: state.announce || '',
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: state.seo_keywords || '',
        },
        { vmid: 'og:title', property: 'og:title', content: state.name || '' },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: state.announce || '',
        },
        { vmid: 'og:image', property: 'og:image', content: mainImageUrl || '' },
        { vmid: 'og:url', property: 'og:url', content: ogUrl || '' },
      ],
      link: [{ rel: 'canonical', href: canonicalLink }],
    };
  },
};
</script>
<style lang="stylus">
.custom-size{
  max-width: 692px;
  max-height: 460px;
  aspect-ratio: 353 / 235;
}
</style>



// WEBPACK FOOTER //
// Card.vue?f42f45f6